import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { listingsApi as r } from "@maat/api-main";
//#region src/properties/useUpdateListingCancellationConfigMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ listingId: e, config: t }) => r.updateListingCancellationConfig(e, t),
		onSuccess: (t, { listingId: n }) => {
			i.invalidateQueries({ queryKey: e.listing(n) });
		}
	});
};
//#endregion
export { i as useUpdateListingCancellationConfigMutation };
